import * as csv from 'helpers/csv';
import { saveFile } from 'helpers/saveFile';
import { formatDuration } from 'helpers/date';
import moment from 'moment';
import { dateFormat } from 'config/common';

const workDateMomentFormat = dateFormat
  .replace('yyyy', 'YYYY')
  .replace('dd', 'DD');

export const exportIndividualStats = (stats, { date, mode }) => {
  const headers = [
    { title: 'Individual', key: 'full_name' },
    {
      title: 'Targets',
      getValue: item => {
        const tot = Math.round(item.tot_containers || 0);
        const inTime = Math.round(item.tot_processes_in_time || 0);
        return `${inTime}/${tot}`;
      },
    },
    {
      title: 'CPH/Person',
      getValue: item => {
        if (item.avg_cph === undefined || item.avg_cph === null) {
          return '-';
        }
        return Math.round(item.avg_cph);
      }
    },
    { title: 'Container Type', key: 'container_class' },
    {
      title: 'Saved time',
      getValue: item => item.avg_saved_mins !== undefined ? formatDuration(item.avg_saved_mins * 60000, false) : '-',
    },
    {
      title: 'Net savings',
      getValue: item => item.avg_net_saved_mins !== undefined ? formatDuration(item.avg_net_saved_mins * 60000, false) : '-',
    },
    {
      title: 'Unload Avg. Duration',
      getValue: item => item.avg_duration !== undefined ? formatDuration(item.avg_duration * 1000, false) : '-',
    },
    {
      title: 'Activity Hours',
      getValue: item => item.avg_minutes_seen ? formatDuration(item.avg_minutes_seen * 60000, false) : '-',
    },
  ];

  let filename = 'individuals';
  switch (mode) {
    case 'date':
      filename += date.format('_DD_MMM_YYYY');
    break;

    case 'week':
      filename += date.format('_wo_[week]_of_YYYY')
    break;

    case 'month':
      filename += date.format('_MMM_YYYY')
    break;

    case 'year':
      filename += date.format('_YYYY');
    break;

    default:
  }

  const csvString = csv.stringify({
    headers,
    data: stats,
  });

  saveFile(csvString, `${filename}.csv`, 'text/csv');
};

export const formatWorkDate = (workDate) => {
  if (!workDate) return '-';
  let parsedWorkDate;
  if (typeof workDate === 'number') {
    const workDateInMs = workDate.toString().length === 10 ? workDate * 1000 : workDate;
    parsedWorkDate = moment(workDateInMs);
  } else {
    parsedWorkDate = moment.parseZone(workDate);
  }

  if (!parsedWorkDate.isValid()) return workDate;
  return parsedWorkDate.format(workDateMomentFormat);
};

export default formatWorkDate;
